import React from 'react';
import BaseComponent from 'src/components/BaseComponent';
import { MCButton, MCText } from 'src/components/basic';
import { lang, remCss } from 'src/helpers';

export default class PaymentResultPopup extends BaseComponent {
  renderIcon = (success) => {
    if (success) {
      return (
        <svg width='64' height='64' viewBox='0 0 64 64' fill='none'>
          <circle cx='32' cy='32' r='32' fill='#34C759' />
          <path
            d='M20 32L28 40L44 24'
            stroke='white'
            strokeWidth='4'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      );
    }
    return (
      <svg width='64' height='64' viewBox='0 0 64 64' fill='none'>
        <circle cx='32' cy='32' r='32' fill='#FF3B30' />
        <path d='M24 24L40 40M40 24L24 40' stroke='white' strokeWidth='4' strokeLinecap='round' />
      </svg>
    );
  };

  getPaymentTypeLabel = (type) => {
    switch (type) {
      case 'chat_ticket':
        return lang.t('Chat Ticket');
      case 'invoice':
        return lang.t('Invoice');
      default:
        return lang.t('Payment');
    }
  };

  formatDate = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  formatAmount = (amount, currency) => {
    const value = amount;
    return `${value} ${currency.toUpperCase()}`;
  };

  render() {
    const { closeBtn, hide, response } = this.props;
    const { err, data } = response || {};

    const success = !err && data?.chargeResult?.success;
    const type = data?.ticket ? 'chat_ticket' : 'invoice';
    const error = err?.message || err;

    const amount = data?.chargeResult?.amount;
    const currency = data?.chargeResult?.paymentIntent?.currency || data?.ticket?.charge?.currency;

    const ticket = data?.ticket;
    const maxMessages = ticket?.maxMessages;
    const endDate = ticket?.endDate;

    console.log('PaymentResultPopup render', { response, data, success, ticket, error });

    return (
      <div className='mc-popup-contain' style={{ width: remCss(450) }}>
        <div className='mc-modal-header'>
          <div className='mc-popup-title'>{lang.t('Payment Result')}</div>
          {closeBtn}
        </div>
        <div className='mc-modal-body mc-flex-15-col' style={{ alignItems: 'center' }}>
          {this.renderIcon(success)}

          <MCText
            label={success ? lang.t('Payment Successful') : lang.t('Payment Failed')}
            size={24}
            weight={600}
            heading
          />

          <div className='mc-flex-col' style={{ width: '100%', gap: remCss(10) }}>
            {success && !error && (
              <div className='mc-flex'>
                <MCText label={lang.t('Type:')} size={16} weight={400} flex />
                <MCText label={this.getPaymentTypeLabel(type)} size={16} weight={600} />
              </div>
            )}

            {amount && currency && (
              <div className='mc-flex'>
                <MCText label={lang.t('Amount:')} size={16} weight={400} flex />
                <MCText label={this.formatAmount(amount, currency)} size={16} weight={600} />
              </div>
            )}

            {type === 'chat_ticket' && maxMessages && (
              <div className='mc-flex'>
                <MCText label={lang.t('Messages:')} size={16} weight={400} flex />
                <MCText label={`${maxMessages} ${lang.t('messages')}`} size={16} weight={600} />
              </div>
            )}

            {type === 'chat_ticket' && endDate && (
              <div className='mc-flex'>
                <MCText label={lang.t('Expires:')} size={16} weight={400} flex />
                <MCText label={this.formatDate(endDate)} size={16} weight={600} />
              </div>
            )}

          </div>
        </div>

        <div className='mc-modal-footer mc-flex'>
          <MCButton
            className='mc-grow'
            primary
            dark
            radius
            medium
            onClick={hide}
            label={lang.t('Close')}
          />
        </div>
      </div>
    );
  }
}

/* data structure

  {
      "ticket": {
          "id": "400469.1191761261628751",
          "entity": "ticket",
          "patientId": 119,
          "doctorId": 400469,
          "convId": "400469.119",
          "startDate": 1761261628751,
          "endDate": 1761693628751,
          "charge": {
              "duration": 5,
              "extraMessage": 1,
              "messagesCount": 5,
              "paid": true,
              "price": 9,
              "currency": "USD"
          },
          "messages": 0,
          "maxMessages": 5,
          "available": true
      },
      "chargeResult": {
          "success": true,
          "paymentIntentId": "pi_3SLXo0GDeqTi0NXt0jMh7cWh",
          "cardId": "pm_1SFmz9GDeqTi0NXtMbROyIpm",
          "amount": 900,
          "status": "succeeded",
          "paymentIntent": {
              "id": "pi_3SLXo0GDeqTi0NXt0jMh7cWh",
              "object": "payment_intent",
              "amount": 900,
              "amount_capturable": 0,
              "amount_details": {
                  "tip": {}
              },
              "amount_received": 900,
              "application": null,
              "application_fee_amount": null,
              "automatic_payment_methods": {
                  "allow_redirects": "always",
                  "enabled": true
              },
              "canceled_at": null,
              "cancellation_reason": null,
              "confirmation_method": "automatic",
              "created": 1761261628,
              "currency": "usd",
              "customer": "cus_T9r6Eo10Z7H5R6",
              "description": "Ticket",
              "invoice": null,
              "last_payment_error": null,
              "latest_charge": "ch_3SLXo0GDeqTi0NXt03XaWvmw",
              "livemode": false,
              "metadata": {},
              "payment_method": "pm_1SFmz9GDeqTi0NXtMbROyIpm",
              "payment_method_types": [
                  "card",
                  "link"
              ],
              "processing": null,
              "receipt_email": null,
              "status": "succeeded",
          }
      }
  }

   */
